(function() {
  'use strict';
  if (window.ZarrSearchInited) return;
  window.ZarrSearchInited = true;

  var HISTORY_KEY = 'zarr_search_history';
  var HISTORY_EXPIRY = 20 * 60 * 1000;

  var keywordMap = [
    { label: 'Lawn', url: '/search?q=lawn&type=product' },
    { label: 'Unstitched', url: '/collections/unstitched' },
    { label: 'Stitched', url: '/collections/all?filter.p.m.custom.stitched=Stitched' },
    { label: 'New Arrivals', url: '/collections/all?sort_by=created-descending' },
    { label: 'Sale', url: '/collections/sale' },
    { label: 'Kurta', url: '/search?q=kurta&type=product' },
    { label: 'Abaya', url: '/search?q=abaya&type=product' },
    { label: 'Jewellery', url: '/collections/jewellery' },
    { label: 'Ready to Wear', url: '/collections/ready-to-wear' },
    { label: 'Summer Collection', url: '/collections/summer-collection' }
  ];

  function hideAllZarrResults() {
    var activeSearch = document.querySelectorAll('.zarr-search-advanced-content.is-active');
    activeSearch.forEach(function(el) {
      el.classList.remove('is-active');
      el.style.display = 'none';
      el.style.opacity = '0';
      el.style.pointerEvents = 'none';
    });
    
    var headerResults = document.querySelectorAll('.header-field-results.is-active');
    headerResults.forEach(function(el) { el.classList.remove('is-active'); el.style.display = 'none'; });
  }

  function getHistory() {
    try {
      var h = localStorage.getItem(HISTORY_KEY);
      if (!h) return [];
      var parsed = JSON.parse(h), now = Date.now();
      return parsed.filter(function(i) {
        return (now - (typeof i === 'string' ? now : i.time)) < HISTORY_EXPIRY;
      }).map(function(i) { return typeof i === 'string' ? i : i.q; });
    } catch(e) { return []; }
  }

  function saveToHistory(q) {
    if (!q || q.length < 2) return;
    try {
      var h = localStorage.getItem(HISTORY_KEY);
      var parsed = h ? JSON.parse(h) : [];
      parsed = parsed.map(function(i) { return (typeof i === 'string') ? { q: i, time: Date.now() } : i; });
      parsed = parsed.filter(function(i) { return i && i.q && i.q.toLowerCase() !== q.toLowerCase(); });
      parsed.unshift({ q: q, time: Date.now() });
      var capped = parsed.slice(0, 5);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(capped));
    } catch(e) {
      console.error("Zarr Search History Error:", e);
    }
  }

  function renderHistory() {
    var h = getHistory();
    if (!h.length) return '';
    return h.map(function(item) {
        var q = typeof item === 'string' ? item : item.q;
        return '<div class="zarr-recent-search-row">' +
                 '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="zarr-recent-text">' + q + '</a>' +
                 '<span class="zarr-recent-remove" data-q="' + q.replace(/"/g, '&quot;') + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg></span>' +
               '</div>';
      }).join('');
  }

  function getContainers(input) {
    if (!input) return null;
    var p = input.closest('.template-search__search, .search-modal, .zarr-sb__inner, .search, body');
    if (!p) return null;
    
    var adv = p.querySelector('.zarr-search-advanced-content');
    if (!adv) return null;

    return {
      advanced: adv,
      recentSec: adv.querySelector('.zarr-recent-searches'),
      recentList: adv.querySelector('.zarr-recent-list'),
      trendingSec: adv.querySelector('.zarr-trending-searches'),
      resultsSec: adv.querySelector('.zarr-keyword-results'),
      resultsList: adv.querySelector('.zarr-keyword-results__list'),
      parent: p
    };
  }

  function activateSearch(input) {
    if (!input) return;
    var c = getContainers(input);
    if (!c || !c.advanced) return;

    var hHtml = renderHistory();
    if (hHtml && c.recentList) {
      c.recentList.innerHTML = hHtml;
      if (c.recentSec) c.recentSec.style.display = 'block';
    } else {
      if (c.recentSec) c.recentSec.style.display = 'none';
    }

    if (!input.value.trim()) {
      c.advanced.classList.add('is-active');
      c.advanced.style.display = 'block';
      c.advanced.style.opacity = '1';
      c.advanced.style.pointerEvents = 'auto';
      if (c.resultsSec) c.resultsSec.style.display = 'none';
      if (c.trendingSec) c.trendingSec.style.display = 'block';
    } else {
      handleInput({ target: input });
    }
  }

  var debounceTimer;
  var abortController;

  function handleInput(e) {
    var input = e.target;
    var c = getContainers(input);
    if (!c) return;
    var q = input.value.trim().toLowerCase();
    clearTimeout(debounceTimer);
    
    if (abortController) {
      abortController.abort();
    }

    if (!q) {
      c.advanced.classList.add('is-active');
      c.advanced.style.display = 'block';
      c.advanced.style.opacity = '1';
      c.advanced.style.pointerEvents = 'auto';
      if (c.resultsSec) c.resultsSec.style.display = 'none';
      if (c.trendingSec) c.trendingSec.style.display = 'block';
      if (c.recentSec && c.recentList && c.recentList.innerHTML.trim() !== '') {
        c.recentSec.style.display = 'block';
      }
      return;
    }
    
    if (c.trendingSec) c.trendingSec.style.display = 'none';
    if (c.recentSec) c.recentSec.style.display = 'none';
    
    debounceTimer = setTimeout(function() {
      abortController = new AbortController();
      var signal = abortController.signal;

      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=query,collection,product&resources[limit]=10', { signal: signal })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (signal.aborted) return;
          var ds = data.resources.results;
          var combined = [].concat(
            keywordMap.filter(function(kw) { return kw.label.toLowerCase().indexOf(q) !== -1; }).slice(0, 3),
            (ds.queries || []).map(function(i){return {label:i.text,url:i.url}}),
            (ds.collections || []).map(function(i){return {label:i.title,url:i.url}})
          );
          var seen = {};
          combined = combined.filter(function(i) { 
             if (!i || !i.label) return false;
             var k = i.label.toLowerCase(); 
             return seen[k] ? false : (seen[k] = true); 
          });

          if (combined.length > 0 && c.resultsList) {
            c.resultsList.innerHTML = combined.slice(0, 10).map(function(i) {
              return '<a href="' + i.url + '" class="zarr-recent-search-row">' +
                       '<span class="zarr-recent-text">' + i.label + '</span>' +
                     '</a>';
            }).join('');
            if (c.resultsSec) c.resultsSec.style.display = 'block';
            c.advanced.classList.add('is-active');
            c.advanced.style.display = 'block';
            c.advanced.style.opacity = '1';
            c.advanced.style.pointerEvents = 'auto';
          } else if (c.resultsSec) {
            c.resultsSec.style.display = 'none';
          }
        }).catch(function(err){
          if (err.name === 'AbortError') return;
          console.error("Search suggest error:", err);
        });
    }, 180);
  }

  // --- INTERACTION HANDLERS ---
  document.addEventListener('click', function(e) {
    var target = e.target;

    // Fast close buttons
    if (target.closest('.button-close, .close-popup, .search-modal__close-button, .modal__close-button, .button-close--search')) {
        hideAllZarrResults();
        return;
    }

    var removeBtn = target.closest('.zarr-recent-remove');
    if (removeBtn) {
      e.preventDefault(); e.stopPropagation();
      var qToRemove = removeBtn.getAttribute('data-q');
      try {
        var h = localStorage.getItem(HISTORY_KEY);
        var parsed = h ? JSON.parse(h) : [];
        parsed = parsed.filter(function(i) { return (typeof i === 'string' ? i : i.q) !== qToRemove; });
        localStorage.setItem(HISTORY_KEY, JSON.stringify(parsed));
        var row = removeBtn.closest('.zarr-recent-search-row');
        if (row) row.remove();
      } catch(x) {}
      return;
    }

    // Click outside logic (Optimized)
    if (document.querySelector('.zarr-search-advanced-content.is-active')) {
      if (!target.closest('.zarr-search-advanced-content, input[type="search"], .search__input, .search-field__text, .search-modal, .search-link, .search-field__icon, .search__icon, summary, .zarr-sb__icon, details')) {
        hideAllZarrResults();
      }
    }

    // Save item to history
    var resultItem = target.closest('.zarr-trending-item, .zarr-recent-text, .zarr-recent-search-row');
    if (resultItem && !target.closest('.zarr-recent-remove')) {
      saveToHistory(resultItem.innerText.trim());
    }
  }, { passive: true });

  document.addEventListener('focusin', function(e) {
    if (e.target.matches('input[type="search"], .search__input, .search-field__text, #Search-In-Template, .zarr-sb__input')) {
      activateSearch(e.target);
      if (!e.target.dataset.zarrInited) {
        e.target.dataset.zarrInited = 'true';
        e.target.addEventListener('input', handleInput);
      }
    }
  });

  document.addEventListener('submit', function(e) {
    var inp = e.target.querySelector('input[type="search"], .search__input, .search-field__text, .zarr-sb__input');
    if (inp) saveToHistory(inp.value.trim());
  });

})();

